/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ConfigureFaxWebhookDto,
  ErrorResponse,
  FaxProfileResponseDto,
  FaxWebhookConfigResponseDto,
  UpdateFaxProfileStatusDto,
  UpsertFaxProfileDto,
} from '../models/index';
import {
    ConfigureFaxWebhookDtoFromJSON,
    ConfigureFaxWebhookDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FaxProfileResponseDtoFromJSON,
    FaxProfileResponseDtoToJSON,
    FaxWebhookConfigResponseDtoFromJSON,
    FaxWebhookConfigResponseDtoToJSON,
    UpdateFaxProfileStatusDtoFromJSON,
    UpdateFaxProfileStatusDtoToJSON,
    UpsertFaxProfileDtoFromJSON,
    UpsertFaxProfileDtoToJSON,
} from '../models/index';

export interface ConfigureFaxProfileWebhookRequest {
    practiceId: string;
    configureFaxWebhookDto: ConfigureFaxWebhookDto;
}

export interface GetFaxProfileRequest {
    practiceId: string;
}

export interface UpdateFaxProfileStatusRequest {
    practiceId: string;
    updateFaxProfileStatusDto: UpdateFaxProfileStatusDto;
}

export interface UpsertFaxProfileRequest {
    practiceId: string;
    upsertFaxProfileDto: UpsertFaxProfileDto;
}

/**
 * 
 */
export class AdminFaxApi extends runtime.BaseAPI {

    /**
     * Builds the Cellera incoming fax webhook URL from the provided public HTTPS base URL, configures the linked Sinch Fax service to send multipart/form-data incoming fax events to that URL, and returns readiness flags for the practice fax number and HIPAA storage settings.
     * Configure Sinch incoming fax webhook for a practice profile
     */
    async configureFaxProfileWebhookRaw(requestParameters: ConfigureFaxProfileWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FaxWebhookConfigResponseDto>> {
        if (requestParameters['practiceId'] == null) {
            throw new runtime.RequiredError(
                'practiceId',
                'Required parameter "practiceId" was null or undefined when calling configureFaxProfileWebhook().'
            );
        }

        if (requestParameters['configureFaxWebhookDto'] == null) {
            throw new runtime.RequiredError(
                'configureFaxWebhookDto',
                'Required parameter "configureFaxWebhookDto" was null or undefined when calling configureFaxProfileWebhook().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/practices/{practiceId}/fax-profile/webhook`.replace(`{${"practiceId"}}`, encodeURIComponent(String(requestParameters['practiceId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ConfigureFaxWebhookDtoToJSON(requestParameters['configureFaxWebhookDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FaxWebhookConfigResponseDtoFromJSON(jsonValue));
    }

    /**
     * Builds the Cellera incoming fax webhook URL from the provided public HTTPS base URL, configures the linked Sinch Fax service to send multipart/form-data incoming fax events to that URL, and returns readiness flags for the practice fax number and HIPAA storage settings.
     * Configure Sinch incoming fax webhook for a practice profile
     */
    async configureFaxProfileWebhook(requestParameters: ConfigureFaxProfileWebhookRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FaxWebhookConfigResponseDto> {
        const response = await this.configureFaxProfileWebhookRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the practice\'s fax profile. Returns 404 when no profile has been provisioned yet.
     * Get the fax profile for a practice
     */
    async getFaxProfileRaw(requestParameters: GetFaxProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FaxProfileResponseDto>> {
        if (requestParameters['practiceId'] == null) {
            throw new runtime.RequiredError(
                'practiceId',
                'Required parameter "practiceId" was null or undefined when calling getFaxProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/practices/{practiceId}/fax-profile`.replace(`{${"practiceId"}}`, encodeURIComponent(String(requestParameters['practiceId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FaxProfileResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns the practice\'s fax profile. Returns 404 when no profile has been provisioned yet.
     * Get the fax profile for a practice
     */
    async getFaxProfile(requestParameters: GetFaxProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FaxProfileResponseDto> {
        const response = await this.getFaxProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Transitions fax profile status through the explicit state matrix: active->suspended/retired, suspended->active/retired with Sinch HIPAA re-validation, draft->retired only, and retired remains terminal. Provisioning and re-provisioning use the PUT endpoint.
     * Update fax profile status
     */
    async updateFaxProfileStatusRaw(requestParameters: UpdateFaxProfileStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FaxProfileResponseDto>> {
        if (requestParameters['practiceId'] == null) {
            throw new runtime.RequiredError(
                'practiceId',
                'Required parameter "practiceId" was null or undefined when calling updateFaxProfileStatus().'
            );
        }

        if (requestParameters['updateFaxProfileStatusDto'] == null) {
            throw new runtime.RequiredError(
                'updateFaxProfileStatusDto',
                'Required parameter "updateFaxProfileStatusDto" was null or undefined when calling updateFaxProfileStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/practices/{practiceId}/fax-profile/status`.replace(`{${"practiceId"}}`, encodeURIComponent(String(requestParameters['practiceId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateFaxProfileStatusDtoToJSON(requestParameters['updateFaxProfileStatusDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FaxProfileResponseDtoFromJSON(jsonValue));
    }

    /**
     * Transitions fax profile status through the explicit state matrix: active->suspended/retired, suspended->active/retired with Sinch HIPAA re-validation, draft->retired only, and retired remains terminal. Provisioning and re-provisioning use the PUT endpoint.
     * Update fax profile status
     */
    async updateFaxProfileStatus(requestParameters: UpdateFaxProfileStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FaxProfileResponseDto> {
        const response = await this.updateFaxProfileStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new fax profile (status=active) or updates an existing draft/active/suspended profile. Validates the Sinch service, confirms the requested fax number belongs to that service, and requires HIPAA compliance (saveInboundFaxDocuments=false, saveOutboundFaxDocuments=false). Retired profiles cannot be re-provisioned.
     * Provision or re-provision a fax profile for a practice
     */
    async upsertFaxProfileRaw(requestParameters: UpsertFaxProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FaxProfileResponseDto>> {
        if (requestParameters['practiceId'] == null) {
            throw new runtime.RequiredError(
                'practiceId',
                'Required parameter "practiceId" was null or undefined when calling upsertFaxProfile().'
            );
        }

        if (requestParameters['upsertFaxProfileDto'] == null) {
            throw new runtime.RequiredError(
                'upsertFaxProfileDto',
                'Required parameter "upsertFaxProfileDto" was null or undefined when calling upsertFaxProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/admin/practices/{practiceId}/fax-profile`.replace(`{${"practiceId"}}`, encodeURIComponent(String(requestParameters['practiceId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertFaxProfileDtoToJSON(requestParameters['upsertFaxProfileDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FaxProfileResponseDtoFromJSON(jsonValue));
    }

    /**
     * Creates a new fax profile (status=active) or updates an existing draft/active/suspended profile. Validates the Sinch service, confirms the requested fax number belongs to that service, and requires HIPAA compliance (saveInboundFaxDocuments=false, saveOutboundFaxDocuments=false). Retired profiles cannot be re-provisioned.
     * Provision or re-provision a fax profile for a practice
     */
    async upsertFaxProfile(requestParameters: UpsertFaxProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FaxProfileResponseDto> {
        const response = await this.upsertFaxProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
